import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'components/Modal';
import Landmark from 'components/Landmark';
var TimeZonePicker = /*#__PURE__*/React.lazy(function () {
  return import('./TimeZonePicker');
});
function TimeZonePickerModal(_ref) {
  var selected = _ref.selected,
    onSubmit = _ref.onSubmit,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Modal, {
    id: "time-zones-picker-modal",
    "aria-label": t('actions_select_timezone'),
    onRequestClose: onClose
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Landmark, {
      icon: "spinner"
    })
  }, /*#__PURE__*/React.createElement(TimeZonePicker, {
    selected: selected,
    onSubmit: onSubmit,
    onClose: onClose
  })));
}
export default TimeZonePickerModal;